module.exports = __webpack_public_path__ + "static/media/teacher-03.f7719699.png";